/**
 * Mock email-template library. Each template carries enough metadata to drive
 * the gallery cards + preview drawer. Swap for API data when backend is ready.
 * `blocks` describes a simple visual skeleton rendered as the thumbnail/preview.
 */
export const TEMPLATE_CATEGORIES = [
  { key: "all",          label: "All" },
  { key: "newsletter",   label: "Newsletter" },
  { key: "promotion",    label: "Promotion" },
  { key: "welcome",      label: "Welcome" },
  { key: "reengagement", label: "Re-engagement" },
  { key: "transactional",label: "Transactional" },
];

const block = (type, w = "100%") => ({ type, w });

export const TEMPLATES = [
  {
    id: "tpl_01",
    name: "Clean Newsletter",
    category: "newsletter",
    description: "Minimal multi-section layout for weekly digests and updates.",
    accent: "var(--color-primary)",
    uses: 128,
    openRate: 41.2,
    updatedAt: "Jun 26, 2026",
    favorite: true,
    subject: "This week in estimating",
    blocks: [block("hero"), block("text", "80%"), block("text", "95%"), block("button", "40%"), block("divider"), block("text", "70%")],
  },
  {
    id: "tpl_02",
    name: "Product Announcement",
    category: "newsletter",
    description: "Bold hero with feature highlights — perfect for launches.",
    accent: "var(--color-info)",
    uses: 86,
    openRate: 51.3,
    updatedAt: "Jun 24, 2026",
    favorite: false,
    subject: "Introducing SwiftEstimate Pro",
    blocks: [block("hero"), block("image"), block("text", "90%"), block("button", "45%")],
  },
  {
    id: "tpl_03",
    name: "Flash Promo / Offer",
    category: "promotion",
    description: "High-contrast CTA-driven layout for limited-time offers.",
    accent: "var(--color-secondary)",
    uses: 64,
    openRate: 38.7,
    updatedAt: "Jun 20, 2026",
    favorite: true,
    subject: "48 hours only — 20% off",
    blocks: [block("badge", "30%"), block("hero"), block("text", "75%"), block("button", "50%")],
  },
  {
    id: "tpl_04",
    name: "Welcome Email",
    category: "welcome",
    description: "Warm onboarding email introducing new signups to your service.",
    accent: "var(--color-success)",
    uses: 212,
    openRate: 67.2,
    updatedAt: "Jun 18, 2026",
    favorite: true,
    subject: "Welcome to SwiftReach 👋",
    blocks: [block("hero"), block("text", "85%"), block("list"), block("button", "40%")],
  },
  {
    id: "tpl_05",
    name: "Win-back Re-engagement",
    category: "reengagement",
    description: "Friendly nudge with incentive to re-activate dormant contacts.",
    accent: "var(--color-high)",
    uses: 39,
    openRate: 28.9,
    updatedAt: "Jun 15, 2026",
    favorite: false,
    subject: "We miss you — here's 20% off",
    blocks: [block("text", "60%"), block("hero"), block("button", "55%"), block("text", "70%")],
  },
  {
    id: "tpl_06",
    name: "Estimate Ready",
    category: "transactional",
    description: "Notify clients their estimate or takeoff is ready to view.",
    accent: "var(--color-primary)",
    uses: 154,
    openRate: 72.4,
    updatedAt: "Jun 12, 2026",
    favorite: false,
    subject: "Your estimate is ready",
    blocks: [block("badge", "35%"), block("text", "90%"), block("button", "45%"), block("divider"), block("text", "60%")],
  },
  {
    id: "tpl_07",
    name: "Monthly Digest",
    category: "newsletter",
    description: "Three-column digest for curated links and stats.",
    accent: "var(--color-info)",
    uses: 47,
    openRate: 34.1,
    updatedAt: "Jun 08, 2026",
    favorite: false,
    subject: "Your June recap",
    blocks: [block("hero"), block("cols3"), block("text", "80%"), block("button", "40%")],
  },
  {
    id: "tpl_08",
    name: "Plain Text",
    category: "transactional",
    description: "Simple text-first layout that feels personal and lands in inbox.",
    accent: "var(--color-text-muted)",
    uses: 91,
    openRate: 58.6,
    updatedAt: "Jun 02, 2026",
    favorite: false,
    subject: "Quick note from our team",
    blocks: [block("text", "95%"), block("text", "85%"), block("text", "90%"), block("text", "40%")],
  },
];
